import axios from "axios";

const instance = axios.create({
  baseURL: "https://tin-der-back-end.herokuapp.com",
});

export default instance;
